var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('top-header'),_c('subheader'),_c('left-menu'),_c('transition',{attrs:{"name":"slide-fade-inverted","mode":"out-in"}},[_c('router-view')],1),_c('GithubButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }